var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoccerFieldIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4C2.89 4 2 4.89 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89 21.1 4 20 4H4ZM4 6H11V8.13C9.24 8.59 8 10.18 8 12C8 13.82 9.24 15.41 11 15.87V18H4V16H7V8H4V6ZM20 6H13V8.13C14.76 8.59 16 10.18 16 12C16 13.82 14.76 15.41 13 15.87V18H20V16H17V8H20V6ZM4 10H5V14H4V10ZM20 10H19V14H20V10ZM13 10.27C13.62 10.63 14 11.29 14 12C14 12.71 13.62 13.37 13 13.73V10.27ZM11 13.73V10.27C10.38 10.63 10 11.29 10 12C10 12.71 10.38 13.37 11 13.73Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoccerFieldIcon);
export default __webpack_public_path__ + "static/media/soccer-field-icon.e7c62ebf9aa0bd1cbf01e89b7ac3d1bb.svg";
export { ForwardRef as ReactComponent };